export const LOCAL_FUNNY_PHOTO_GUIDE_VIDEO_URL =
  '/local-media/funny-photo/guide.mp4';
export const LOCAL_FUNNY_PHOTO_CLEAR_VIDEO_URL =
  '/local-media/funny-photo/clear.mp4';

function trimmedUrl(value) {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function shouldUseLocalMedia(environment, localMediaFlag) {
  return environment === 'development' && localMediaFlag === 'true';
}

/** 명시적으로 허용한 로컬 개발 환경에서만 검증 영상을 사용한다. */
export function resolveFunnyPhotoGuideVideoUrl(
  spot,
  environment = process.env.NODE_ENV,
  localMediaFlag = process.env.REACT_APP_FUNNY_PHOTO_LOCAL_MEDIA,
) {
  if (!spot || spot.mission_type !== 'funny_photo') return null;
  if (shouldUseLocalMedia(environment, localMediaFlag)) {
    return LOCAL_FUNNY_PHOTO_GUIDE_VIDEO_URL;
  }
  return trimmedUrl(spot.mission_video_url);
}

/** 명시적으로 허용한 로컬 개발 환경에서만 검증 영상을 사용한다. */
export function resolveFunnyPhotoClearVideoUrl(
  config,
  environment = process.env.NODE_ENV,
  localMediaFlag = process.env.REACT_APP_FUNNY_PHOTO_LOCAL_MEDIA,
) {
  if (shouldUseLocalMedia(environment, localMediaFlag)) {
    return LOCAL_FUNNY_PHOTO_CLEAR_VIDEO_URL;
  }
  return trimmedUrl(config?.clear_video_url);
}
